import React, { Component } from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ReactTable from 'Common/ReactTableWrapper';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { PrintBarcodeEnum } from 'Common/FieldEnum';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

class ItemListContainer extends Component {
  static propTypes = {
    itemListData: PropTypes.array,
    onSortedChange: PropTypes.func,
    onFilteredChange: PropTypes.func,
    sorted: PropTypes.array,
    filtered: PropTypes.array,
    reactTableRef: PropTypes.object,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    itemListData: [],
    onSortedChange: () => {},
    onFilteredChange: () => {},
    sorted: [],
    filtered: [],
    reactTableRef: null,
    loading: false,
  };

  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = currentRows.data;
        const filteredData = [];
        const checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[PrintBarcodeEnum.ItemId]
            ? obj[PrintBarcodeEnum.ItemId]
            : obj._original[PrintBarcodeEnum.ItemId];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length && checkAllIds.length === dataObjs.length
            )}
            onClick={(e, data) => {
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: ({ original }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                this.props.input.value.indexOf(
                  original[PrintBarcodeEnum.ItemId]
                ) !== -1
              }
              onClick={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: PrintBarcodeEnum.ItemId,
      ...ReactTableWrapperColumnProperties,
      filterable: false,
      sortable: false,
      maxWidth: 200,
    },
    {
      Header: 'Item Code',
      accessor: PrintBarcodeEnum.ItemCode,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Item Description',
      accessor: PrintBarcodeEnum.Description,
      ...ReactTableWrapperColumnProperties,
    },
  ];

  handleHeaderLevelCheckBox = (filteredData, checked, dataObjs) => {
    const {
      input: { value },
    } = this.props;
    if (checked) {
      this.props.input.onChange([...filteredData, ...value]);
    } else {
      const copySelected = [...filteredData, ...value];
      _.forEach(dataObjs, obj => {
        const id = obj[PrintBarcodeEnum.ItemId]
          ? obj[PrintBarcodeEnum.ItemId]
          : obj._original[PrintBarcodeEnum.ItemId];
        const index = copySelected.indexOf(id);
        if (index !== -1) {
          copySelected.splice(index, 1);
        }
      });
      this.props.input.onChange(copySelected);
    }
  };

  handleChangeCheckbox = (original, checked) => {
    const { input } = this.props;
    const formValues =
      input.value && input.value.length ? [...input.value] : [];
    const index = formValues.indexOf(original[PrintBarcodeEnum.ItemId]);
    if (checked && index === -1) {
      formValues.push(original[PrintBarcodeEnum.ItemId]);
    } else if (index > -1) {
      formValues.splice(index, 1);
    }
    input.onChange(formValues);
  };
  render() {
    const {
      itemListData,
      loading,
      onSortedChange,
      sorted,
      filtered,
      reactTableRef,
      onFilteredChange,
    } = this.props;

    return (
      <Form.Field>
        <ReactTable
          defaultPageSize={20}
          showPageSizeOptions={true}
          minRows={0}
          data={itemListData}
          noDatatext={itemListData ? '' : 'No rows found'}
          resizable={false}
          className={'-striped -highlight modalGrid'}
          columns={this.columns}
          loading={loading}
          loadingText={loading ? 'Loading...' : ''}
          defaultFilterMethod={caseInsensitiveFilter}
          reactTableRef={reactTableRef}
          onFilteredChange={onFilteredChange}
          onSortedChange={onSortedChange}
          sorted={sorted}
          filtered={filtered}
          menu={false}
          saveState={{
            tableName: TableNamesEnum.CK_PRINT_BARCODES_TABLE,
          }}
        />
      </Form.Field>
    );
  }
}

export default ItemListContainer;



// WEBPACK FOOTER //
// ./src/pages/utilities/printbarcodes/containers/ItemListContainer.js